
    // IMPORTS
    import { computed, defineComponent, PropType, ref } from 'vue'

    import { Button } from '@progress/kendo-vue-buttons'
    import { FontIcon } from '@progress/kendo-vue-common'
    import { BoolField } from '../fields'

    import { buildLocalization } from '@/util'

    export default defineComponent({
        name: 'boolSwitchCell',

        components: {
            BoolField,
            'k-button': Button,
            FontIcon
        },

        emits: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            save: (target: InstanceType<typeof Button> | null, newValue:boolean, username: string) => true
        },

        props: {
            dataItem: { type: Object as PropType<any>, required: true },
            field: { type: String as PropType<string>, required: true },
            className: { type: String as PropType<string>, required: false, default: () => null },
            rowType: { type: String as PropType<string>, required: false, default: () => '' },
            isGroupRender: { type: Boolean as PropType<boolean>, default: () => false },
        },

        setup(props, { emit }) {
            /********************************************************************************************************************
             INIT
             ********************************************************************************************************************/

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const modelValue = ref<boolean>(props.dataItem[props.field])            
            const btnSave = ref<InstanceType<typeof Button> | null>(null)
            const publicData = { modelValue, btnSave }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const propValue = computed(() => props.dataItem[props.field])
            const isDirty = computed(() => propValue.value != modelValue.value)
            const computedData = { propValue, isDirty }

            /********************************************************************************************************************
             PUBLIC METHODS
             ********************************************************************************************************************/
            const { localize } = buildLocalization()

            function save(username: string) {
                emit('save', btnSave.value, modelValue.value, username)
            }

            const publicMethods = { localize, save }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
